var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconfinder_BW_Twitter_glyph_svg_5305170","d":"M7.741,67.987A14.271,14.271,0,0,0,22.109,53.618c0-.219,0-.436-.015-.653a10.275,10.275,0,0,0,2.519-2.614,10.081,10.081,0,0,1-2.9.795,5.068,5.068,0,0,0,2.22-2.793,10.122,10.122,0,0,1-3.207,1.226,5.055,5.055,0,0,0-8.606,4.606A14.344,14.344,0,0,1,1.713,48.908,5.075,5.075,0,0,0,3.277,55.65a5.012,5.012,0,0,1-2.292-.632v.064a5.067,5.067,0,0,0,4.051,4.95,5.043,5.043,0,0,1-2.28.087,5.066,5.066,0,0,0,4.718,3.507A10.136,10.136,0,0,1,1.2,65.791,10.272,10.272,0,0,1,0,65.719a14.3,14.3,0,0,0,7.741,2.264","transform":"translate(0 -47.987)","fill":"#222"}));
}

TwitterInline.defaultProps = {"width":"24.614","height":"20","viewBox":"0 0 24.614 20"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
